const mutations = {
  setOnCost(state, data) {
    state.oncostEdit = data
  },
  setDeleteOnCost(state, data) {
    state.oncostDelete = data
  }
}

export default mutations